import "../styles/sections/content-hero.styles.css"
import { BtnTogether1 } from "../elements/BtnTogether1"

export const ContentHero = () => {
    return (
        <section id="hero-sec" className="content-hero">
            <div className="content-hero-card-primary">
                <p className="title-content-hero-card">10 de anos no mercado de pré-moldados</p>
                <h1>Reconhecida pela eficiência e alta qualidade, a Premold oferece soluções rápidas e precisas para diversos setores.</h1>
                <BtnTogether1 />
            </div>
            <div className="container-cards">
                <div className="content-hero-card">
                    <p className="title-content-hero-card">+80 Projetos</p>
                    <p>Com vasta experiência e um portfólio diversificado, a Premold atende a diversas indústrias e comércios, sempre garantindo satisfação e excelência em cada obra.</p>
                </div>
                <div className="content-hero-card">
                    <p className="title-content-hero-card">+5 Estados</p>
                    <p>incluindo ES, RJ, MG, GO, DF e BH. Com uma ampla presença regional, a empresa oferece soluções de alta qualidade em construção de galpões pré-moldados, atendendo às necessidades específicas de cada cliente com eficiência e compromisso.</p>
                </div>
            </div>
        </section>
    )
}